<template>
  <div class="order-item">
    <div class="d-flex mt-3">
      <div
        v-if="value && value.product_record && value.product_record.image_url"
        class="item-image"
        :style="{ backgroundImage: 'url(' + value.product_record.image_url + ')' }"
      >
      </div>
      <div class="item-details pl-2 flex-grow-1">
        <div class="px-3">
          <strong>{{ value.product }}</strong>
          <!-- <div>Red - Medium</div> -->
          <div>Quantity: {{ (value && value.amount) || '0' }}</div>
        </div>
        <v-btn
          v-if="value.amount_refunded < value.amount && !(order && ['Q', 'F', 'X'].includes(order.status)) && canReturn"
          text
          small
          class="mt-2"
          color="error"
          @click="$store.commit('setReturnsDialog', true)"
        >Request Return</v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item-status {
  opacity: 0.7;
  font-size: 20px;
  line-height: 20px;
}
.item-image {
  width: 100px;
  height: 100px;
  background-size: contain;
}
</style>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      default: null
    }
  },
  computed: {
    // Only allow returns for orders < 30 days ago
    canReturn () {
      return this.order &&
        this.order.date &&
        ((Date.now() / 1000) - this.order.date) < (3600 * 24 * 30)
    }
  }
}
</script>
